import { useForm } from "react-hook-form";
import AuthCodeApi from "../../api/auth-code";
import Auth from "../../api/auth";
import { useContext, useState } from "react";
import AuthContext from "../auth-context";
import { useTranslation } from "react-i18next";
import Alert from "../login/alert";
export interface IVerifyNumberProps {
  username: string;
  onSubmit: (authId: string) => void;
  handleAlert: (data: boolean) => void;
  alert: Boolean;
  serviceType: string;
}

interface IVerifyFormData {
  code: string;
}

export default function VerifyNumber({
  username,
  onSubmit,
  handleAlert,
  alert,
  serviceType,
}: IVerifyNumberProps) {
  const { register, handleSubmit, formState } = useForm<IVerifyFormData>();
  const context = useContext(AuthContext);
  const { errors } = formState;
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const { t } = useTranslation(undefined, { keyPrefix: "SignUp.VerifyNumber" });

  function onFormSubmit(data: IVerifyFormData) {
    setErrorMessage("");
    new AuthCodeApi()
      .put({
        username,
        code: data.code,
        serviceType,
      })
      .then((res) => {
        if (res.errorMessages) setErrorMessage(res.errorMessages);
        else
          Auth.login({
            username,
            password: data.code,
            serviceType,
          }).then((data) => {
            context.login(data.LoginId);
            onSubmit(data.LoginId);
          });
      });
  }

  function handleForgot() {
    const api = new AuthCodeApi();
    api.post({ username, serviceType }).then((res) => {
      console.log(res);
      handleAlert(true);
    });
  }

  return (
    <form onSubmit={handleSubmit(onFormSubmit)} className="signup-section">
      <div className="xs:w-full md:w-2/4 xl:w-2/6 mx-auto xs:p-0  mt-10 p-10 rounded-xl">
        <div className="signup-form-head-section mb-2 flex-col flex">
          <span className="sepanta-icon-mobile icon-box"></span>
          <h3 className="head-title pt-4">{t("Cell Number Confirmation")}</h3>
        </div>
        {alert ? (
          <Alert color="green" message={t("Resend code alert")} />
        ) : null}
        <div className="form-section rtl flex flex-grow flex-col gap-4 mb-0">
          <div className="form-group flex flex-col w-full rtl text-center  mt-2 relative">
            <label htmlFor="" className="pr-4 mb-10">
              {t("enter the code", { username: username })}
            </label>
            <input
              {...register("code")}
              type="tel"
              className="border-2 p-4 rounded-lg mt-2 text-center verify-code-input"
              placeholder="- - - - -"
            />
            <p className="absolute left-0 right-0 top-8 text-red-500">
              {errors.code?.message} {errorMessage}
            </p>
          </div>
        </div>

        <div className="form-section rtl flex flex-col mt-6 gap-4 justify-between pb-10">
          <button className="verify-account-btn p-5 flex text-center justify-center">
            {t("Submit")}
            <span className="sepanta-icon-left-long-arrow"></span>
          </button>

          <button
            className="flex items-center justify-center navigate-link-bd"
            onClick={handleForgot}
          >
            {t("Resend the code")}
          </button>
        </div>
      </div>
    </form>
  );
}
